// extracted by mini-css-extract-plugin
export default {"title":"Main_title__RpaPk","wrapper":"Main_wrapper__QlbGe","content":"Main_content__P6Vny","date":"Main_date__dGzFn"};